/**
 * Application initialization utilities for app state management
 * This module handles initialization of app_state cookie from URL parameters
 * on page load, similar to the vite plugin functionality in patient-onboarding
 */

import { initializeAppStateFromUrl } from './zipCodeIntegration';

/**
 * Initialize application state management on app startup
 * This function should be called once when the application starts
 * to restore app_state cookie from URL parameters if available
 */
export const initializeAppState = (): void => {
  try {
    // Initialize app_state cookie from URL parameters
    initializeAppStateFromUrl();
  } catch (error) {
    console.error('[App Initialization] Error initializing app state:', error);
  }
};

/**
 * Debug function to log current app state for development
 * Only logs in development mode
 */
export const logAppStateDebugInfo = (): void => {
  if (process.env.NODE_ENV === 'development') {
    const urlParams = new URLSearchParams(window.location.search);
    const stateFromUrl = urlParams.get('state');
    const zipFromUrl = urlParams.get('zipCode');

    if (document.cookie) {
      const cookies = document.cookie.split(';');
      cookies.forEach((cookie) => {
        const parts = cookie.trim().split('=');
        if (parts.length === 2) {
          console.log(`[App State Debug] Cookie: ${parts[0]} = ${parts[1]}`);
        }
      });
    } else {
      console.log('[App State Debug] No cookies found');
    }
  }
};
